import { createFileRoute } from '@tanstack/react-router';
import * as React from 'react';

import { PageHeader } from '@/components/dashboard/page-header';
import { AiPreferences } from '@/components/settings/ai-preferences';
import { DataExport } from '@/components/settings/data-export';
import { DeleteAccount } from '@/components/settings/delete-account';

export const Route = createFileRoute('/_app/settings/privacy')({
  component: PrivacySettingsPage,
});

function PrivacySettingsPage(): React.ReactElement {
  return (
    <div className="flex flex-col gap-6">
      <PageHeader
        title="Confidentialité"
        subtitle="Contrôlez l'usage de vos données et exercez vos droits (RGPD)."
      />
      <AiPreferences />
      <DataExport />
      <DeleteAccount />
    </div>
  );
}
